<template>
  <div class="app-main__inner">
    <breadcrumb />
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8 mt-5">
        <div class="main-card mb-3 card">
          <div class="card-body">
            <h4 class=""></h4>
            <p>
              This service is temporarily unavailble, please try again later.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
// import AuthenticationService from "@/services/AuthenticationService";
import Breadcrumb from "@/components/_partials/Breadcrumb";
export default {
  name: "Data",
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: "%s | Data subscription",
    meta: [
      {
        name: "description",
        content: "We are coming soon",
      },
      {
        name: "keywords",
        content: "We will fix this soon",
      },
    ],
  },
  components: {
    Breadcrumb
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped></style>
